
namespace Areas.Submittal.Profile {
    "use strict";
       

    export function updateSubmittalProfile() {
        const form = $("#SubmittalProfileForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Submittal/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT",
                () => Areas.refreshGrid("SubmittalTrackingProfilesGrid"));
        }
    }

    //contact lookup
    export function selectContractor() {
        const form: any = $("#SubmittalProfileForm").dxForm("instance");
        const parameters = { accountId: form.option("AccountId") };

        const accountTeamLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(accountTeamDialogClosing("Contractor"), parameters);
    }

    export function selectArchitect() {
        const form: any = $("#SubmittalProfileForm").dxForm("instance");
        const parameters = { accountId: form.option("AccountId") };

        const accountTeamLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(accountTeamDialogClosing("Architect"), parameters);
    }

    export function selectCM() {
        const form: any = $("#SubmittalProfileForm").dxForm("instance");
        const parameters = { accountId: form.option("AccountId") };

        const accountTeamLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(accountTeamDialogClosing("CM"), parameters);
    }

    export function selectCoordinator() {
        const form: any = $("#SubmittalProfileForm").dxForm("instance");
        const parameters = { accountId: form.option("AccountId") };

        const accountTeamLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(accountTeamDialogClosing("Coordinator"), parameters);
    }

    function accountTeamDialogClosing(buttonId: string) {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#SubmittalProfileForm").dxForm("instance");
            const formData: any = form.option("formData");

            if (buttonId === "Contractor") {
                formData.ContractorContactId = data.contactId;
                formData.ContractorContactName = data.displayName;
                formData.ContractorCompanyName = data.companyName;

            } else if (buttonId === "CM") {
                formData.CMContactId = data.contactId;
                formData.CMContactName = data.displayName;
                formData.CMCompanyName = data.companyName;

            } else if (buttonId === "Coordinator") {
                formData.CoordinatorContactId = data.contactId;
                formData.CoordinatorContactName = data.displayName;
                formData.CoordinatorCompanyName = data.companyName;

            } else if (buttonId === "Architect") {
                formData.ArchitectContactId = data.contactId;
                formData.ArchitectContactName = data.displayName;
                formData.ArchitectCompanyName = data.companyName;
            }
           
            form.option("formData", formData);
       
        }
    } 

    //select Account
    function accountDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#SubmittalProfileForm").dxForm("instance");
            const formData: any = form.option("formData");

            formData.AccountId = data.accountId;
            formData.AccountName = data.accountName;

            form.option("formData", formData);

        }
    }


    export function selectAccount() {
        const form: any = $("#SubmittalProfileForm").dxForm("instance");

        const accountLookupDialog =
            new Areas.Dialogs.AccountDialog(accountDialogClosing());
    }    

    //select Contract
    function contractDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const form: any = $("#SubmittalProfileForm").dxForm("instance");
            const formData: any = form.option("formData");

            formData.ContractId = data.contractId;
            formData.ContractName = data.contractName;
            formData.ContractAmount = data.contractAmount;
            formData.ContractType = data.contractType;

            form.option("formData", formData);

        }
    } 


    export function selectContract() {
        const form: any = $("#SubmittalProfileForm").dxForm("instance");

        const contractLookupDialog =
            new Areas.Dialogs.ContractDialog(contractDialogClosing());
    }    


}
